import { render, staticRenderFns } from "./folder.vue?vue&type=template&id=3b8b7f1a&scoped=true&"
import script from "./folder.vue?vue&type=script&lang=ts&"
export * from "./folder.vue?vue&type=script&lang=ts&"
import style0 from "./folder.vue?vue&type=style&index=0&id=3b8b7f1a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8b7f1a",
  null
  
)

export default component.exports